// client/src/lib/tourDemo.js
//
// Tiny external store coordinating the spotlight tour with the Client Groups
// page (which lives in the routed Outlet, outside the KB Navigator's subtree):
//   • demo — show the curated demo fixtures instead of the viewer's real book,
//            and short-circuit every write so a curious click can't mutate prod.
//
// SpotlightTour flips the flag while mounted; ClientGroupsSection reads it via
// useTourDemo() and swaps in the demo data (clientGroupingDemoData.js), while
// resolveActionQueue + PhaseSignoffBar read tourDemo.getDemo() to no-op writes.
//
// Archivable: deleting this file + clientGroupingDemoData.js and reverting the
// call-site edits fully removes the tour demo-data feature.

import { useSyncExternalStore } from 'react';

let demoOn = false;
const subscribers = new Set();
const emit = () => subscribers.forEach((fn) => fn());

export const tourDemo = {
  setDemo(value) { if (demoOn !== value) { demoOn = value; emit(); } },
  subscribe(fn) {
    subscribers.add(fn);
    return () => { subscribers.delete(fn); };
  },
  getDemo() { return demoOn; },
};

// Convenience for non-React call sites (write-path guards).
export function getDemo() { return demoOn; }

export function useTourDemo() {
  return useSyncExternalStore(tourDemo.subscribe, tourDemo.getDemo, () => false);
}
